import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { ISiteStatusData } from '@components/contractor360/components/contractorNavigation';

interface ISiteStatusDetails {
	mutate: UseMutateFunction<ISiteStatusData, Error, ISiteStatusData, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useUpdateSiteStatus = (): ISiteStatusDetails => {
	const updateSiteStatusData = async (siteData: ISiteStatusData): Promise<ISiteStatusData> => {
		const { site_lead, status } = siteData;
		const url = `${APICONFIG.ADD_SITE_STATUS}${site_lead}/`;
		return await APIService.patchData<ISiteStatusData>(url, { status });
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: updateSiteStatusData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
